module.exports = __webpack_public_path__ + "static/golf-logo.44da300a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/golf-logo.svg
// module id = 85
// module chunks = 47976874282846 213534597649335